import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import SortedTooltip from './SortedTooltip';
import ChartEmptyState from './ChartEmptyState';
import InfoTooltip from './InfoTooltip';

interface Props {
  title: string;
  data: Record<string, string | number>[];
  nameKey: string;
  valueKey: string;
  colors: string[];
  height?: number;
  info?: string;
}

const SimplePieChartCard = ({ title, data, nameKey, valueKey, colors, height = 220, info }: Props) => {
  // Bind each row's colour by its original index BEFORE filtering out zero slices,
  // so the colour stays attached to the category even when some are absent.
  const slices = (data || [])
    .map((row, originalIndex) => ({ row, color: colors[originalIndex % colors.length] }))
    .filter((slice) => Number(slice.row[valueKey]) > 0);

  return (
    <div className="bg-white rounded-lg shadow p-4 w-full">
      <div className="flex items-center gap-1.5 mb-4">
        <h3 className="text-sm font-semibold text-gray-700">{title}</h3>
        {info && <InfoTooltip text={info} />}
      </div>
      {!slices.length ? (
        <ChartEmptyState height={height} />
      ) : (
        <ResponsiveContainer width="100%" height={height}>
          <PieChart>
            <Pie
              data={slices.map((slice) => slice.row)}
              dataKey={valueKey}
              nameKey={nameKey}
              cx="50%"
              cy="50%"
              outerRadius={70}
              isAnimationActive={false}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              label={(entry: any) => `${entry[nameKey]}: ${entry[valueKey]}`}
            >
              {slices.map((slice, index) => (
                <Cell key={`cell-${index}`} fill={slice.color} />
              ))}
            </Pie>
            <Tooltip content={<SortedTooltip />} />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default SimplePieChartCard;
